"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const HelpIcon = ({ size = 32, fill = "none", title = "Help", ...rest }) => {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, fill: fill, viewBox: "0 0 32 32", ...rest },
        react_1.default.createElement("title", null, title),
        react_1.default.createElement("path", { d: "M10,12.9c0-3.5,2.2-5.9,5.8-5.9s5.2,1.8,5.2,4.8-1.1,3.1-2.1,4c-1.2,1-2.1,1.8-2.1,4.1h-2.6c0-2.8.6-3.8,1.9-4.9,1-.9,1.9-1.5,1.9-3.1s-1.5-2.7-2.4-2.7c-2,0-2.9,1.4-2.9,3.6h-2.7ZM14,22h3v3h-3v-3Z", fill: "#fff" })));
};
exports.default = HelpIcon;
//# sourceMappingURL=index.js.map